var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-grid"
  }, [_vm.filterPhotoRow && _vm.filterPhotoRow.length ? _c('div', {
    staticClass: "product-grid__photo-filter"
  }, [_c('RowSliderNew', {
    attrs: {
      "list": _vm.filterPhotoRow,
      "offset-between-elements": 10
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var el = _ref.el;
        return [_c('RowPhotoFilter', {
          attrs: {
            "el": el,
            "photo-lazyload": _vm.rowPhotoFilterPhotoLazyload
          },
          on: {
            "click": function ($event) {
              return _vm.emit('photo-row-filter-change', $event);
            }
          }
        })];
      }
    }], null, false, 726364712)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "product-grid__desktop-filter"
  }, [_vm._t("headerDesktopFilter", function () {
    return [!_vm.hideFilterRow && _vm.filterFirstRow.length || _vm.filterSecondRow.length ? _c('div', {
      staticClass: "product-grid__row-filter"
    }, [_c('FilterRowWrapper', [_vm.filterFirstRow.length ? _c('FilterRow', {
      attrs: {
        "value": _vm.filterFirstRowValue,
        "list": _vm.filterFirstRow,
        "tag": _vm.filterTag
      },
      on: {
        "change": function ($event) {
          return _vm.emit('filter-first-row-change', $event);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.filterSecondRow.length ? _c('FilterRow', {
      attrs: {
        "value": _vm.filterSecondRowValue,
        "list": _vm.filterSecondRow,
        "tag": _vm.filterTag
      },
      on: {
        "change": function ($event) {
          return _vm.emit('filter-second-row-change', $event);
        }
      }
    }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), !_vm.hideSort && _vm.sortList.length ? _c('div', {
      staticClass: "product-grid__desktop-sort"
    }, [_c('Sort', {
      attrs: {
        "list": _vm.sortList,
        "value": _vm.activeSort,
        "availability": _vm.availability
      },
      on: {
        "sort": function ($event) {
          return _vm.emit('sort', $event);
        },
        "availability-change": function ($event) {
          return _vm.emit('availability-change', $event);
        }
      }
    })], 1) : _vm._e()];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "product-grid__mobile-filter"
  }, [_c('div', {
    staticClass: "product-grid__mobile-filter-row"
  }, [_vm._t("headerMobileFilterButton"), _vm._v(" "), _vm._t("headerMobileFilter", function () {
    return [_vm.sortList.length ? _c('div', {
      staticClass: "product-grid__mobile-sort"
    }, [_c('SortSelect', {
      attrs: {
        "list": _vm.sortList,
        "value": _vm.activeSort
      },
      on: {
        "change": function ($event) {
          return _vm.emit('sort', $event);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm.filterFirstRow.length ? _c('div', {
      staticClass: "product-grid__select-filter"
    }, [_c('SelectFilter', {
      attrs: {
        "placeholder": _vm.selectFilterPlaceholder,
        "value": _vm.filterFirstRowValue,
        "list": _vm.filterFirstRow
      },
      on: {
        "change": function ($event) {
          return _vm.emit('filter-first-row-change', $event);
        }
      }
    })], 1) : _vm._e()];
  }, {
    "onSort": _vm.onSort,
    "activeSort": _vm.activeSort,
    "sortList": _vm.sortList,
    "filterSecondRowValue": _vm.filterSecondRowValue,
    "filterFirstRow": _vm.filterFirstRow,
    "filterFirstRowValue": _vm.filterFirstRowValue,
    "onFilterFirstRowChange": _vm.onFilterFirstRowChange,
    "selectFilterPlaceholder": _vm.selectFilterPlaceholder,
    "changeCardsMobileType": _vm.changeCardsMobileType,
    "cardsMobileType": _vm.cardsMobileType
  }), _vm._v(" "), (_vm.sortList.length || _vm.filterFirstRow.length) && !_vm.isMobileGridTypeBtnOnSecondRow ? _c('div', {
    staticClass: "product-grid__product-cards-mobile-type",
    on: {
      "click": _vm.changeCardsMobileType
    }
  }, [_vm.cardsMobileType === 'grid' ? _c('img', {
    staticClass: "product-grid__product-cards-mobile-type-img",
    attrs: {
      "src": require("@/assets/images/svg/list-icon.svg")
    }
  }) : _c('img', {
    staticClass: "product-grid__product-cards-mobile-type-img",
    attrs: {
      "src": require("@/assets/images/svg/grid-icon.svg")
    }
  })]) : _vm._e()], 2), _vm._v(" "), _vm.filterSecondRow.length ? _c('div', {
    staticClass: "product-grid__tag-filter-wrapper"
  }, [_c('TagHorizontalFilter', {
    attrs: {
      "padding": "0px 10px",
      "value": _vm.filterSecondRowValue,
      "list": _vm.filterSecondRow
    },
    on: {
      "change": function ($event) {
        return _vm.emit('filter-second-row-change', $event);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMobileGridTypeBtnOnSecondRow ? _c('div', {
    staticClass: "product-grid__product-cards-mobile-type mt-16",
    on: {
      "click": _vm.changeCardsMobileType
    }
  }, [_vm.cardsMobileType === 'grid' ? _c('img', {
    staticClass: "product-grid__product-cards-mobile-type-img",
    attrs: {
      "src": require("@/assets/images/svg/list-icon.svg")
    }
  }) : _c('img', {
    staticClass: "product-grid__product-cards-mobile-type-img",
    attrs: {
      "src": require("@/assets/images/svg/grid-icon.svg")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "product-grid__grid",
    class: [{
      'product-grid__grid_loading': _vm.loading
    }]
  }, [_vm.productList && _vm.productList.length ? _c('TSProductCardGrid', {
    attrs: {
      "media": _vm.media
    }
  }, _vm._l(_vm.productList, function (product, index) {
    var _vm$_b;

    return _c('TSProductCard', _vm._b({
      key: product.id,
      staticClass: "product-card-grid__el product-card-grid__el_bt-0",
      class: [{
        'product-card_adaptive': _vm.cardsMobileType === 'grid',
        'product-card_more': _vm.cardsMobileType === 'list'
      }],
      attrs: {
        "item-index": index,
        "product": product,
        "data-e2e": "product-card",
        "data-e2e-product-card-id": product.id,
        "photo-lazyload": index < _vm.countProductCardPhotoNoLazyload ? _vm.productCardPhotoLazyload : true,
        "mobile-type": _vm.cardsMobileType,
        "source": _vm.listName,
        "hide": _vm.hide
      },
      on: {
        "remove-favorite": function ($event) {
          return _vm.emit('remove-favorite', $event);
        },
        "product-select": function ($event) {
          return _vm.emit('product-select', {
            index: index,
            product: product
          });
        },
        "add-product": function ($event) {
          return _vm.emit('add-product', product);
        }
      }
    }, 'TSProductCard', (_vm$_b = {}, _vm$_b[("data-e2e-product-card-" + (product.id))] = product.id, _vm$_b), false));
  }), 1) : _c('div', {
    staticClass: "product-grid__empty-grid"
  }, [_vm._t("empty", function () {
    return [_c('div', {
      staticClass: "h3"
    }, [_vm._v("\n            Нет товаров\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "p"
    }, [_vm._v("\n            Пожалуйста, сбросьте фильтры\n          ")])];
  })], 2)], 1), _vm._v(" "), _vm.pagination.current && _vm.pagination.count > 1 ? _c('div', {
    staticClass: "product-grid__pagination"
  }, [_c('TSHybridPagination', {
    attrs: {
      "quantity-on-page": _vm.quantityOnPage,
      "pagination": {
        count: _vm.pagination.count,
        current: _vm.pagination.current,
        itemQuantity: _vm.pagination.itemQuantity
      },
      "link": _vm.linkPage
    },
    on: {
      "change-page": function ($event) {
        return _vm.emit('change-page', $event);
      },
      "load-more": function ($event) {
        return _vm.emit('load-more', $event);
      }
    }
  })], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }